export default {
  "baseURL": "https://api.v2.thereddot.navadhiti.com/api"

};
    